"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFinleyAiThreadWithPromptResponses = exports.isFinleyAiThread = exports.isFinleyAiPromptResponse = exports.isFinleyAiTextractSupportedFileExtension = exports.isFinleyAiVirtualSheetSupportedFileExtension = exports.isTransformExtractionConfigArray = exports.isFinleyAiTransformSupportedFileExtension = exports.isFinleyAiExtractValuesSupportedFileExtension = exports.isFinleyAiRequest = void 0;
const _ = __importStar(require("lodash"));
const schema = __importStar(require("../schema"));
const FinleyAiTypes = __importStar(require("../types/FinleyAi"));
const FinleyAi_1 = require("../types/FinleyAi");
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isFinleyAiRequest = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: FinleyAi_1.FinleyAiRequestSchema,
    typeguardName: 'isFinleyAiRequest',
});
exports.isFinleyAiExtractValuesSupportedFileExtension = (0, typeguardUtils_1.zodTypeGuard)(FinleyAiTypes.FinleyAiExtractValuesSupportedFileExtensionSchema);
exports.isFinleyAiTransformSupportedFileExtension = (0, typeguardUtils_1.zodTypeGuard)(FinleyAiTypes.FinleyAiTransformSupportedFileExtensionSchema);
exports.isTransformExtractionConfigArray = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: FinleyAi_1.TransformExtractionConfigArraySchema,
    typeguardName: 'isTransformExtractionConfigArray',
});
const isFinleyAiVirtualSheetSupportedFileExtension = (obj) => {
    return FinleyAi_1.FinleyAiVirtualSheetSupportedFileExtensionIterable.includes(obj);
};
exports.isFinleyAiVirtualSheetSupportedFileExtension = isFinleyAiVirtualSheetSupportedFileExtension;
exports.isFinleyAiTextractSupportedFileExtension = (0, typeguardUtils_1.zodTypeGuard)(FinleyAiTypes.FinleyAiTextractSupportedFileExtensionSchema);
// Use Zod schemas for validation (Wire schemas use string dates for JSON serialization)
// The type casts are needed because Wire schemas produce string dates but runtime types expect Date objects.
// The actual date validation is done by hasCreatedAtAndUpdatedAtJsDate in the exported functions.
const _isFinleyAiPromptResponse = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.FinleyAiPromptResponseWireSchema,
    typeguardName: 'isFinleyAiPromptResponse',
});
const _isFinleyAiThread = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.FinleyAiThreadWireSchema,
    typeguardName: 'isFinleyAiThread',
});
const _isFinleyAiThreadWithPromptResponses = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.FinleyAiThreadWithPromptResponsesWireSchema,
    typeguardName: '_isFinleyAiThreadWithPromptResponses',
});
const isFinleyAiPromptResponse = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiPromptResponse',
        logInputs,
    })) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
    };
    return _isFinleyAiPromptResponse(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiPromptResponse = isFinleyAiPromptResponse;
const isFinleyAiThread = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiThread',
        logInputs,
    })) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
    };
    return _isFinleyAiThread(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiThread = isFinleyAiThread;
const isFinleyAiThreadWithPromptResponses = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiThreadWithPromptResponses',
        logInputs,
    })) {
        return false;
    }
    if (!('promptResponses' in obj)) {
        if (logInputs && logInputs.logger) {
            logInputs.logger({
                message: `Expected FinleyAiThreadWithPromptResponses to contain property promptResponses.`,
            }, logInputs.logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    if (!Array.isArray(obj.promptResponses)) {
        if (logInputs && logInputs.logger) {
            logInputs.logger({
                message: `Expected FinleyAiThreadWithPromptResponses promptResponses to be typeof Array.`,
            }, logInputs.logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    if (!_.every(obj.promptResponses, (pr) => (0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj: pr,
        typeName: 'FinleyAiThreadWithPromptResponses',
        logInputs,
    }))) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
        // already safe to cast of Object[]
        promptResponses: obj.promptResponses.map((pr) => ({
            ...pr,
            created_at: obj.created_at.toISOString(),
            updated_at: obj.updated_at.toISOString(),
        })),
    };
    return _isFinleyAiThreadWithPromptResponses(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiThreadWithPromptResponses = isFinleyAiThreadWithPromptResponses;
//# sourceMappingURL=finleyAi.js.map